import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import '../styles/Services.css';

const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Gallery images - Digital Ads Portfolio only
  const galleryImages = [
    '/assets/img/digital_ads_portfolio/digital-portfolio.jpg',
    '/assets/img/digital_ads_portfolio/digital-portfolio2.webp',
    '/assets/img/digital_ads_portfolio/digital-portfolio3.webp',
    '/assets/img/digital_ads_portfolio/digital-portfolio4.jpg',
  ];

  // Services data
  const services = [
    {
      id: 'tv-ads',
      title: 'TV Ads',
      icon: '/assets/ads_icons/tv-ads.png',
      image: true
    },
    {
      id: 'Influencer-ads',
      title: 'Influencer Ads',
      icon: '/assets/ads_icons/influencer-ads.png',
      image: true
    },
    {
      id: 'digital-ads',
      title: 'Digital Ads',
      icon: '/assets/ads_icons/digital-ads.png',
      image: true
    },
    {
      id: 'theater-ads',
      title: 'Theater Ads',
      icon: '/assets/ads_icons/theater-ads.png',
      image: true
    },
    {
      id: 'concept-ads',
      title: 'Concept Ads',
      icon: '/assets/ads_icons/concept-ads.png',
      image: true
    },
    {
      id: 'commercials',
      title: 'Commercials',
      icon: '/assets/ads_icons/commercials-ads.png',
      image: true
    }
  ];

  const [activeSection, setActiveSection] = useState('tv-ads');

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Service details
  const serviceDetails = {
    'tv-ads': {
      title: 'TV Ads',
      description: 'TV Ads are one of the most impactful ways to build brand awareness and emotionally connect with a mass audience. Television advertising combines visuals, audio, and storytelling to leave a lasting impression on viewers. With the ability to reach millions of households, TV commercials boost brand credibility and trust, especially when aired during prime time or popular shows. Whether you\'re launching a new product, promoting a service, or building long-term recognition, TV ads help your business gain wide exposure and drive consumer action. At ARK Moving Images, we craft high-quality, emotionally driven TV ads that resonate with your target audience and inspire them to engage with your brand.',
      video: '/assets/img/service_details/tv-ads.mp4',
      type: 'video'
    },
    'Influencer-ads': {
      title: 'Influencer Ads',
      description: 'Influencer Ads are dynamic visual advertisements that capture attention and drive engagement across digital platforms. These compelling video commercials combine storytelling, motion graphics, and high-quality production to deliver your brand message effectively. Video ads work exceptionally well on social media platforms, streaming services, and websites, offering higher engagement rates compared to static advertisements. They help build brand awareness, increase conversions, and create memorable experiences for your target audience. At ARK Moving Images, we create impactful video ads that resonate with viewers and deliver measurable results for your business.',
      video: '/assets/img/service_details/influencer-ads.mp4',
      type: 'video'
    },
    'commercials': {
      title: 'Commercial Ads',
      description: 'Commercial Ads are powerful tools to present your brand, product, or service in a compelling and memorable way. These professionally produced advertisements are designed to communicate your message quickly and effectively, often in 15 to 60 seconds. Whether aired on television, online platforms, or cinema, commercial ads create emotional appeal, build brand identity, and influence purchasing decisions. They help your business stand out in a crowded market, attract new customers, and boost conversions. At ARK Moving Images, we specialize in crafting impactful commercial ads that connect with audiences and drive real business results.',
      video: '/assets/img/service_details/commerical-ads.mp4',
      type: 'video'
    },
    'digital-ads': {
      title: 'Digital Ads',
      description: 'Digital Ads play a crucial role in expanding your business by reaching targeted audiences across platforms like Google, Facebook, Instagram, and YouTube. Unlike traditional advertising, digital ads allow precise targeting based on demographics, interests, and user behavior. This ensures your message reaches the right people at the right time. With options like search ads, display banners, video ads, and remarketing, businesses can increase brand awareness, generate leads, and boost sales effectively. At ARK Moving Images, we create high-performance digital ad campaigns that deliver measurable results and help your brand grow online.',
      image: '/assets/img/service_details/digital_ads.jpg',
      type: 'image'
    },
    'theater-ads': {
      title: 'Theater Ads',
      description: 'Theatre advertising offers a powerful way to engage audiences in a distraction-free environment. With large screens, impactful visuals, and immersive sound, your brand message is delivered with maximum attention. By targeting specific locations and movie genres, you can reach a relevant audience, build brand recognition, and create lasting impressions. Theatre ads are ideal for launching new products, promoting events, or enhancing local brand awareness.',
      image: '/assets/img/service_details/theater-ads.jpg',
      type: 'image'
    },
    'concept-ads': {
      title: 'Concept Ads',
      description: 'Concept ads focus on powerful storytelling and emotionally engaging ideas that connect deeply with your target audience. Instead of just selling a product or service, they communicate your brand\'s vision, values, and identity. By creating memorable and thought-provoking visuals, concept ads build trust, increase brand recall, and inspire customer loyalty. When done right, they spark conversations, enhance visibility, and ultimately drive long-term business growth.',
      video: '/assets/img/service_details/concept-ads.mp4',
      type: 'video'
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [galleryImages.length]);

  useEffect(() => {
    // Handle anchor navigation when page loads
    const hash = window.location.hash.substring(1);
    if (hash) {
      setActiveSection(hash);
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);


  // Removed scroll-to-top button per request

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleWhatsAppClick = () => {
    const whatsappMessage = `Hi Ark Moving Images`;
    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappNumber = (process.env.REACT_APP_WHATSAPP || process.env.WHATSAPP || process.env.REACT_APP_PHONE_NUMBER || '').toString();
    const whatsappURL = whatsappNumber ? `https://wa.me/91${whatsappNumber}?text=${encodedMessage}` : '#';
    if (whatsappNumber) window.open(whatsappURL, '_blank');
  };

  return (
    <div className="services-page">
      {/* Full Page Background Video */}
      <video autoPlay muted loop playsInline className="services-page-video">
        <source src="/assets/hero section videos/hero sections 3.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="services-page-overlay"></div>

      {/* Hero Section */}
      <section className="services-hero">
        <div className="services-hero-content">
          <h1 className="services-hero-title">Grab the Audience's Attention from Every Home!</h1>
        </div>
      </section>

      {/* Services Grid */}
      <section className="modern-services-section">
        <div className="modern-services-container">
          <div className="modern-services-header">
            <h2 className="modern-services-title">
              <span className="modern-title-accent">Our</span> Services
            </h2>
            <p className="modern-services-subtitle">
              Comprehensive advertising solutions tailored to elevate your brand
            </p>
          </div>
          
          <div className="modern-services-grid">
            {services.map((service, index) => (
              <div 
                key={service.id} 
                className="modern-service-card"
                onClick={() => scrollToSection(service.id)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="modern-service-icon">
                  {service.image ? (
                    <img src={service.icon} alt={service.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  ) : (
                    service.icon
                  )}
                </div>
                <h3 className="modern-service-title">{service.title}</h3>
                <p className="modern-service-description">
                  Professional {service.title.toLowerCase()} solutions designed to maximize your reach and impact.
                </p>
                <button 
                  className="modern-service-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    scrollToSection(service.id);
                  }}
                >
                  Learn More
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14" />
                    <path d="M12 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Details Sections */}
      {Object.entries(serviceDetails).map(([key, detail], index) => (
        <section key={key} id={key} className={`service-detail-section ${key}-section`}>
          <div className="service-detail-container">
            <div className="service-detail-header">
              <h2 className="service-detail-title">{detail.title}</h2>
            </div>
            <div className="service-detail-content">
              {index % 2 === 0 ? (
                <>
                  <div className="service-detail-media">
                    {detail.type === 'video' ? (
                      <div className="service-video-container">
                        <video className="service-video" controls autoPlay muted loop playsInline>
                          <source src={detail.video} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    ) : (
                      <div className="service-image-container">
                        <img src={detail.image} alt={detail.title} className="service-image" />
                      </div>
                    )}
                  </div>
                  <div className="service-detail-text">
                    <p className="service-detail-description">{detail.description}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="service-detail-text">
                    <p className="service-detail-description">{detail.description}</p>
                  </div>
                  <div className="service-detail-media">
                    {detail.type === 'video' ? (
                      <div className="service-video-container">
                        <video className="service-video" controls autoPlay muted loop playsInline>
                          <source src={detail.video} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    ) : (
                      <div className="service-image-container">
                        <img src={detail.image} alt={detail.title} className="service-image" />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      ))}

      {/* Portfolio Gallery */}
      <section className="portfolio-gallery-section">
        <h2 className="gallery-heading">Our Advertising Portfolio</h2>
        <div className="gallery-container">
          <div className="gallery-slider">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className={`gallery-slide ${index === currentSlide ? 'active' : ''}`}
              >
                <img src={image} alt={`Portfolio ${index + 1}`} className="gallery-image" />
              </div>
            ))}
          </div>
          <div className="gallery-nav">
            <button className="gallery-btn" onClick={prevSlide}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15,18 9,12 15,6" />
              </svg>
            </button>
            <div className="gallery-dots">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  className={`gallery-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
            <button className="gallery-btn" onClick={nextSlide}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9,18 15,12 9,6" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      <Footer />

      {/* Floating Buttons */}
      <button className="whatsapp-btn" onClick={handleWhatsAppClick} aria-label="WhatsApp" title="Start conversation: Hi Ark Moving Images">
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
        <span className="whatsapp-tooltip">Start conversation: Hi Ark Moving Images</span>
      </button>
    </div>
  );
};

export default Services;
